import { RadioField, useFormContext } from '@calendly/form';
import { FieldError, useErrorId } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { DateRangePickerInput } from '@calendly/ui/components/date-range-picker-input';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { dateNotationSelector, timezoneSelector } from 'selectors/current_user';
import { getPrettyDateRange } from './get_pretty_date_range';
import { OptionContainer } from './option_container';
const wrapperCompactCss = "wquz2ep";
const wrapperIsSmallPhoneCss = "w7mzi4w";
const wrapperCss = "wng31xq";
const Wrapper = forwardRef((props, ref) => {
  const {
    compact,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperCompactCss]: compact,
    [wrapperIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const dateRangeContainerCompactCss = "duvtbum";
const dateRangeContainerIsSmallPhoneCss = "ddk9rr2";
const dateRangeContainerCss = "d17wdthd";
const DateRangeContainer = forwardRef((props, ref) => {
  const {
    compact,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <Component ref={ref} {...restProps} className={classNames(dateRangeContainerCss, {
    [dateRangeContainerCompactCss]: compact,
    [dateRangeContainerIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const dateRangeInputCss = "d1daecyt";
const DateRangeInput = forwardRef((props, ref) => <DateRangePickerInput ref={ref} {...props} className={classNames(dateRangeInputCss, props.className)} />);
const radioButtonCss = "r7n7ird";
const RadioButton = forwardRef((props, ref) => <RadioField ref={ref} {...props} className={classNames(radioButtonCss, props.className)} />);
const DateRangeField = ({
  compact
}) => {
  const timezone = useSelector(timezoneSelector);
  const dateNotation = useSelector(dateNotationSelector);
  const {
    values: {
      periodType,
      startDate,
      endDate
    },
    errors: {
      startDate: error
    },
    setFieldValue,
    setFieldTouched
  } = useFormContext();
  const errorId = useErrorId({
    error
  });
  const onChange = ([start, end]) => {
    setFieldTouched('startDate', true);
    setFieldTouched('endDate', true);
    setFieldValue('startDate', start, true);
    setFieldValue('endDate', end);
  };
  if (periodType !== 'fixed') return null;
  return <DateRangeContainer compact={compact}>
      <DateRangeInput aria-label={I18n.t('publisher.event_types.availability.booking_range_fieldset.fixed_label')} aria-describedby={errorId} value={getPrettyDateRange({
      startDate,
      endDate,
      dateNotation
    })} startDate={startDate} endDate={endDate} timezone={timezone} onChange={onChange} />
      <FieldError text={error} id={errorId} />
    </DateRangeContainer>;
};
export const FixedOption = ({
  compact = false,
  spaceless = false
}) => {
  const {
    values: {
      periodType
    },
    setFieldError
  } = useFormContext();
  useEffect(() => {
    setFieldError('startDate', undefined);
  }, [periodType, setFieldError]);
  return <OptionContainer data-component="date_range_field" spaceless={spaceless}>
      <Wrapper compact={compact}>
        <RadioButton name="periodType" value="fixed" label={<span>
              {I18n.t('publisher.event_types.availability.booking_range_fieldset.fixed_label')}
            </span>} />
        <DateRangeField compact={compact} />
      </Wrapper>
    </OptionContainer>;
};

require("./fixed_option.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./fixed_option.js");